module.exports = __webpack_public_path__ + "static/media/lsl-dark.cc9ac1d6.jpeg";